import { PhoneNumberSchema } from '@guiker/phone-number'
import { ageVerification, yup } from '@guiker/yup-util'

import { Personal } from '../../../entity'

const legalNameSchema = yup.object<{
  firstName: string
  middleName?: string
  lastName: string
}>({
  firstName: yup.string().required(),
  middleName: yup.string().nullable(),
  lastName: yup.string().required(),
})

export const updateLegalProfileSchema = yup.object<Personal>({
  legalName: legalNameSchema.required(),
  dateOfBirth: yup
    .string()
    .required()
    .test({
      name: 'ageMustOver18',
      test: (date) => ageVerification({ date }),
    }),
  preferredName: yup.string().nullable(),
  emailAddress: yup.string().required(),
  phone: PhoneNumberSchema(true).required(),
  address: yup
    .object({
      streetNumber: yup.string().required(),
      street: yup.string().required(),
      postalCode: yup.string().required(),
      city: yup.string().required(),
      state: yup.string().required(),
      country: yup.string().required(),
    })
    .required(),
})
